import Toastify from 'toastify-js';
import 'toastify-js/src/toastify.css';

export function sampleServiceForm() {
  const form = document.querySelector('.wp-block-sample-service-form form');
  const submitButton = form.querySelector('[type="submit"]');
  const productButtons = form.querySelectorAll('.product-choice');
  const sampleItems = form.querySelectorAll('[data-sample-id]');
  const sampleSelectButtons = form.querySelectorAll('.sample-select');
  const toggleButton = document.getElementById('toggle-all-products');
  const step1 = document.querySelector('.step[data-step="1"]');

  let availableSampleIds = new Set();
  let selectedSampleIds = new Set();
  let selectedProductId = '';

  initializeProductFilters();
  checkURLForProductId(); // Check for product_id in URL on page load

  // Function to check for product_id in URL and auto-select it
  function checkURLForProductId() {
    const urlParams = new URLSearchParams(window.location.search);
    const productIdFromURL = urlParams.get('product_id');
    if (productIdFromURL) {
      // Find the matching product button
      const matchingButton = Array.from(productButtons).find(
        (button) => button.getAttribute('data-product-id') === productIdFromURL,
      );
      if (matchingButton) {
        // Select the product automatically
        const parentLi = matchingButton.closest('li');
        const sampleIds = (matchingButton.getAttribute('data-sample-ids') || '')
          .split(',')
          .filter(Boolean);
        resetSelections();
        selectProduct(matchingButton, parentLi, sampleIds);
        updateSampleVisibility();
        // Scroll to the product section
        matchingButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }

  // Toggle product selection
  productButtons.forEach((button) => {
    const parentLi = button.closest('li');

    button.addEventListener('click', () => {
      const sampleIds = (button.getAttribute('data-sample-ids') || '')
        .split(',')
        .filter(Boolean);
      const isActive = button.getAttribute('aria-pressed') === 'true';

      resetSelections();

      if (isActive) {
        deselectProduct(button, parentLi);
      } else {
        selectProduct(button, parentLi, sampleIds);
      }

      updateSampleVisibility();
    });
  });

  // Toggle individual sample selection
  sampleSelectButtons.forEach((button) => {
    const parentLi = button.closest('li');

    button.addEventListener('click', () => {
      const sampleId = parentLi.getAttribute('data-sample-id');
      const isActive = button.getAttribute('aria-pressed') === 'true';

      if (!isActive && selectedSampleIds.size >= 2) {
        showToast(window.js_localizations.max_samples_message);
        return;
      }

      toggleSampleSelection(button, parentLi, sampleId, isActive);
      updateSampleVisibility();
    });
  });

  // Toggle visibility of extra products
  if (toggleButton && step1) {
    toggleButton.addEventListener('click', function () {
      const extraProducts = step1.querySelectorAll('.show-more');
      const isExpanded = step1.classList.toggle('expanded');

      extraProducts.forEach((el) => {
        el.classList.toggle('hidden', !isExpanded);
      });

      toggleButton
        .querySelector('.show-more-text')
        .classList.toggle('hidden', isExpanded);
      toggleButton
        .querySelector('.show-less-text')
        .classList.toggle('hidden', !isExpanded);
      toggleButton.setAttribute(
        'aria-label',
        toggleButton.querySelector('span:not(.hidden)').textContent.trim(),
      );
    });
  }

  // Handle form submission
  form.addEventListener('submit', (event) => {
    event.preventDefault();

    form.classList.add('loading');
    submitButton.setAttribute('aria-pressed', 'true');

    const formData = new FormData(form);
    formData.append('action', 'sample_service_submit');
    formData.append('product_id', selectedProductId);
    formData.append('sample_ids', Array.from(selectedSampleIds).join(','));

    fetch(window.js_localizations.ajax_url, {
      method: 'POST',
      body: formData,
    })
      .then((response) => response.json())
      .then(handleFormResponse)
      .catch(handleFormError)
      .finally(() => {
        form.classList.remove('loading');
        submitButton.setAttribute('aria-pressed', 'false');
      });
  });

  // Reset all selections
  function resetSelections() {
    availableSampleIds.clear();
    selectedSampleIds.clear();
    selectedProductId = '';
  }

  // Deselect product
  function deselectProduct(button, parentLi) {
    button.setAttribute('aria-pressed', 'false');
    button.classList.remove('active');
    parentLi.classList.remove('active');
    selectedProductId = '';
  }

  // Select product
  function selectProduct(button, parentLi, sampleIds) {
    productButtons.forEach((btn) => {
      btn.setAttribute('aria-pressed', 'false');
      btn.classList.remove('active');
      btn.closest('li').classList.remove('active');
    });

    button.setAttribute('aria-pressed', 'true');
    button.classList.add('active');
    parentLi.classList.add('active');
    selectedProductId = button.getAttribute('data-product-id') || '';

    sampleIds.forEach((id) => availableSampleIds.add(id));
  }

  // Toggle sample selection
  function toggleSampleSelection(button, parentLi, sampleId, isActive) {
    if (isActive) {
      button.setAttribute('aria-pressed', 'false');
      button.classList.remove('active');
      parentLi.classList.remove('active');
      selectedSampleIds.delete(sampleId);
    } else {
      button.setAttribute('aria-pressed', 'true');
      button.classList.add('active');
      parentLi.classList.add('active');
      selectedSampleIds.add(sampleId);
    }
  }

  // Update sample visibility
  function updateSampleVisibility() {
    const step2 = document.querySelector('[data-step="2"]');
    const step3 = document.querySelector('[data-step="3"]');

    step2.toggleAttribute('inert', availableSampleIds.size === 0);
    step3.toggleAttribute('inert', selectedSampleIds.size === 0);

    sampleItems.forEach((item) => {
      const sampleId = item.getAttribute('data-sample-id');
      const button = item.querySelector('button');

      item.style.display =
        availableSampleIds.size === 0 || availableSampleIds.has(sampleId)
          ? ''
          : 'none';

      if (!selectedSampleIds.has(sampleId)) {
        button.classList.remove('active');
        button.setAttribute('aria-pressed', 'false');
      }
    });
  }

  // Show Toast message
  function showToast(message, duration = 3000) {
    Toastify({
      text: message,
      duration: duration,
      close: true,
      gravity: 'top',
      position: 'center',
      stopOnFocus: true,
    }).showToast();
  }

  // Handle form submission response
  function handleFormResponse(response) {
    if (response.success) {
      showToast(response.data.message || 'Success', -1); // -1 = infinite (until closed)

      form.reset();
      resetSelections();
      updateSampleVisibility();
      productButtons.forEach((btn) => {
        btn.setAttribute('aria-pressed', 'false');
        btn.classList.remove('active');
        btn.closest('li').classList.remove('active');
      });

      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    } else {
      showToast(response.data.message || 'Error', 7500);
    }
  }

  // Handle form submission error
  function handleFormError(error) {
    console.error('Error:', error);
    showToast(window.js_localizations.network_error_message, 5000);
  }

  function initializeProductFilters() {
    const filterButtons = document.querySelectorAll('#product-filters button');
    const productItems = document.querySelectorAll('.step[data-step="1"] li');

    // Initialize - ensure "Alle" filter is active
    let activeFilter = '*';

    // Add click event to each filter button
    filterButtons.forEach((button) => {
      button.addEventListener('click', function () {
        if (button.getAttribute('aria-pressed') == 'true') {
          activeFilter = '*';
          applyFilter('*');
          this.setAttribute('aria-pressed', 'false');
        } else {
          const filter = this.getAttribute('data-filter');

          // Update active state on buttons
          filterButtons.forEach((btn) => {
            btn.setAttribute('aria-pressed', 'false');
          });
          this.setAttribute('aria-pressed', 'true');

          // Store active filter
          activeFilter = filter;

          // Apply filtering
          applyFilter(filter);
        }
      });
    });

    function checkSelectedProductAgainstFilter(filterValue) {
      // Find the currently selected product
      const selectedProduct = document.querySelector(
        '.product-choice[aria-pressed="true"]',
      );

      if (!selectedProduct) return;

      const productLi = selectedProduct.closest('li');

      // Check if the selected product matches the current filter
      const matchesFilter =
        filterValue === '*' || productLi.dataset.productType == filterValue;

      // If the product doesn't match the filter, deselect it
      if (!matchesFilter) {
        deselectProduct(selectedProduct, productLi);
        resetSelections();
        updateSampleVisibility();
      }
    }

    function applyFilter(filterValue) {
      // First, check if the currently selected product should be unselected
      checkSelectedProductAgainstFilter(filterValue);

      // Show/hide products based on filter
      productItems.forEach((product) => {
        if (filterValue === '*') {
          // Show all products but respect the show-more limit
          if (
            product.classList.contains('show-more') &&
            !document
              .querySelector('.step[data-step="1"]')
              .classList.contains('expanded')
          ) {
            product.classList.add('hidden');
          } else {
            product.classList.remove('hidden');
          }
        } else {
          // If product has the filter class, show it, otherwise hide it
          if (product.dataset.productType == filterValue) {
            product.classList.remove('hidden');
          } else {
            product.classList.add('hidden');
          }
        }

        if (document.getElementById('toggle-all-products')) {
          if (filterValue == '*') {
            document
              .getElementById('toggle-all-products')
              .classList.remove('!hidden');
          } else {
            document
              .getElementById('toggle-all-products')
              .classList.add('!hidden');
          }
        }
      });

      // Update the visibility of "show more" button
      updateShowMoreButtonVisibility(filterValue);
    }

    function updateShowMoreButtonVisibility(filterValue) {
      const toggleButton = document.getElementById('toggle-all-products');
      if (!toggleButton) return;

      // Count visible and hidden items with current filter
      const filteredItems =
        filterValue === '*'
          ? productItems
          : Array.from(productItems).filter(
              (item) => item.dataset.productType == filterValue,
            );

      const hiddenFilteredItems = Array.from(filteredItems).filter(
        (item) =>
          item.classList.contains('show-more') &&
          item.classList.contains('hidden'),
      );

      // Only show the button if there are hidden items with current filter
      if (hiddenFilteredItems.length > 0) {
        toggleButton.style.display = '';
      } else {
        toggleButton.style.display = 'none';
      }
    }

    // Initialize with default filter (all)
    applyFilter('*');

    // Update filter state when "show more" is clicked
    const toggleButton = document.getElementById('toggle-all-products');
    if (toggleButton) {
      const originalClickHandler = toggleButton.onclick;

      toggleButton.onclick = function (e) {
        // Call original handler first
        if (originalClickHandler) {
          originalClickHandler.call(this, e);
        }

        // Then re-apply current filter
        setTimeout(() => {
          applyFilter(activeFilter);
        }, 10);
      };
    }
  }

  async function checkURLForProductId() {
    const urlParams = new URLSearchParams(window.location.search);
    const productIdFromURL = urlParams.get('product_id');

    if (productIdFromURL) {
      // Find the matching product button
      const matchingButton = Array.from(productButtons).find(
        (button) => button.getAttribute('data-product-id') === productIdFromURL,
      );

      if (matchingButton) {
        // Get the parent li element
        const parentLi = matchingButton.closest('li');
        const parentElement = parentLi.parentElement;
        const relatedProductFilterButton = form.querySelector(
          `button[data-filter="${parentLi.dataset.productType}"]`,
        );

        // Automatically filter on selected product's product type (request from Ronald)
        await new Promise((resolve) => setTimeout(resolve, 200));
        relatedProductFilterButton.click();

        // Move product to front of the list
        parentElement.insertBefore(parentLi, parentElement.firstChild);

        // Select the product automatically
        const sampleIds = (matchingButton.getAttribute('data-sample-ids') || '')
          .split(',')
          .filter(Boolean);
        resetSelections();
        selectProduct(matchingButton, parentLi, sampleIds);
        updateSampleVisibility();
      }
    }
  }
}
